export default __webpack_public_path__ + "static/media/blk_diamond.1055183b.png";